import { request } from 'util/request';

async function getZones() {
  return request('geo/zones');
}

export { getZones }
